<script lang="ts">
  import { buttonStyle, buttonSwap } from './../stores'; 	/* Load Global Data */
  export let orientation, defaultstyle
  let i_size	= '30px';  /* Icons Size */

	/* Toggle between Button Colour Styles */
	function toggleButtonStyle() {
		$buttonStyle == 'default' ? buttonStyle.set('mtn') : $buttonStyle == 'mtn' ? buttonStyle.set('colour') : buttonStyle.set('default');
	}
  /* Toggle Left/Right mode */
	function toggleSwap() {		    $buttonSwap = !$buttonSwap;		}
</script>



<div class="recess {orientation} {defaultstyle ? 'shadow' : 'glass'} recess-{$buttonStyle}">

  <button on:click|preventDefault={toggleButtonStyle} class="button button-{$buttonStyle}" id="button_style">
    <svg width="{i_size}" height="{i_size}" class="label label-{$buttonStyle}">
      <image xlink:href="icons/icon-controller.svg" src="icons/icon-controller.png" width="{i_size}" height="{i_size}" />
    </svg>
  </button>

  <button on:click|preventDefault={toggleSwap} class="button button-{$buttonStyle}" id="button_swap">
    <svg width="{i_size}" height="{i_size}" class="label label-{$buttonStyle}">
      <image xlink:href="icons/icon-swap.svg" src="icons/icon-swap.png" width="{i_size}" height="{i_size}" />
    </svg>
  </button>

</div>

<!-- FIGURE OUT HOW TO ADD DOWNSCALING HERE
<div class="downscale" on:click|preventDefault={downscale}>
  <button>change quality</button>
</div> -->

<style>
  #button_style {
    /* border: 1px solid red; */
    /* float: left; */
    /* left:0; */
  }
  #button_swap {
    /* border: 1px solid green; */

    left:15px;
    /* float: right !important; */
  }
  /* Default button styles*/
  .recess, .button, .label {
    transition: all 0.2s;
  }
  .button:active {
    background-color: #fff !important;
  }
  /* Default styles */
  .label {
    font-size: 1.3rem;
    font-weight: 700;
    margin-top: 0%;
    color: rgba(0,0,0,0.3);
  }
  .recess {
    /* border: 1px solid green; */
    /* position: relative; */
    width: 105px;
  }
  .button {
    position: relative;
    float: left;
    padding: 0 !important;
    margin: 0 !important;
  }
  /* Default theme */
  .recess-default {
    box-shadow: inset 0 10px 15px rgb(0 0 0 / 30%);
  }
  .button-default {
    background-color: rgba(0,0,0,0.1);
    border: 1.5px solid rgba(255,255,255,1);
  }
  .button-default svg.label {
    color: rgba(255,255,255,0.75);
  }

  /* Xbox Theme: {buttonStlye} value toggles between "default", "mtn" and "colour" */
  .recess-colour {
    background-color: rgba(0, 0, 0, 0);
    /* background: linear-gradient(0deg, rgba(255,255,255,0.2) 0%, rgba(0,0,0,0.2) 100%); */
    box-shadow: none !important;
  }
  .button-colour {
    background-color: #3cdb4e;		/* Xbox Green */
    background: linear-gradient(0deg, rgba(155,155,155,1) 0%, rgba(200,200,200,1) 40%, rgba(200,200,200,1) 60%, rgba(255,255,255,1) 100%);
    box-shadow: inset 0 -4px 0px rgb(0 0 0 / 30%);
  }
  .label-colour {
    margin-top: -5%;
    filter: invert(100);
    opacity: 0.3;
  }
  .button-colour:active {
    box-shadow: inset 0 -1px 0px rgb(0 0 0 / 30%) !important;
  }
  .button-colour:active .label-colour {
    margin-top: 0%;
  }

  /* MTN Theme: {buttonStlye} value toggles between "default" and "mtn" */
  .recess-mtn {
    background-color: rgba(0, 0, 0, 0.75);
    box-shadow: none !important;
  }
  .button-mtn {
    background-color: #ffc107;		/* MTN Yellow */
    box-shadow: none !important;
  }
  .label-mtn {
    margin-top: 5%;
    filter: invert(100);
  }


  /* Orientations */
  .T { top: 0;}
  .B { bottom: 0;}
  .L { left: 0;}
  .R { right: 0;}

  .TM { top: 10%; }
  .BM { bottom: 10%; }
  .LM { left: 10%; }
  .RM { right: 10%; }

</style>
